export default {
      id: "siglevel-none-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#siglevel-none",
      toString: function () {
        return this.url;
      }
    }